var pagination = {
	backwardText: "предыдущая страница",
	forwardText: "следующая страница",
	pageRangeText: "Стр. {current} из {total}",
	itemsPerPageText: "Элементов на странице",
	itemRangeText: "{start}-{end} из {total} элементов",
	pageNumberText: "текущая страница"
};
var searchPlaceholder = "Поиск...";
var ruTranslations = {
	pagination: pagination,
	searchPlaceholder: searchPlaceholder
};

export { ruTranslations as default, pagination, searchPlaceholder };
